import { UserBadge } from "../common/UserBadge"
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import formatTimeAgo from "../hooks/formatTimeAgo";
import { InboxNotificationModel, InboxNotificationType } from "../../store/features/inboxSlice";
import { NotificationsListResponse } from "../../api/requests/interfaces/Notifications";
import { NotificationType } from "../../store/features/notificationsSlice";
import { useTimeAgo } from "../../utils/hooks/useTimeAgo";

export interface RentalNotificationCardProps {
    data: NotificationsListResponse;
    // {
    //     rentalTitle: string;
    //     name: string;
    //     profileImg: string;
    //     lastMessage: string;
    //     dateCreated: Date;
    //     userVerified?: boolean;
    //     rentalIsActive: boolean
    // };

    onClick: () => void;
}

const getNotificationText = (data: NotificationsListResponse) => {
    switch (data.notificationType) {
        case InboxNotificationType.RENTAL_REQUESTED:
            return <><span className="font-semibold">{data.senderName}</span>
            <span>soovib rentida toodet</span>
            <span className="text-primary font-semibold">{data.productName}</span></>
        case InboxNotificationType.RENTAL_APPROVED:
            return <><span className="font-semibold">{data.senderName}</span>
            <span>Kinnitas teie renditaotluse tootele </span>
            <span className="text-primary font-semibold">{data.productName}</span>
            </>
        case InboxNotificationType.MESSAGE_SENT:
            return <><span className="font-semibold">{data.senderName}</span>
            <span>saatis uue sõnumi</span></>
        case InboxNotificationType.RENTAL_RETURNED:
            return <><span className="font-semibold">{data.senderName}</span>
            <span>Märkis toote</span>
            <span className="text-primary font-semibold">{data.productName}</span>
            <span>tagastatuks</span></>
        case InboxNotificationType.NEW_MESSAGE:
            return <><span className="font-semibold">{data.senderName}</span>
            <span>saatis uue sõnumi tootele </span>
            <span className="text-primary font-semibold">{data.productName}</span></>
    }
}

export const RentalNotificationCard: React.FC<RentalNotificationCardProps> = ({ data, onClick }) => {
    const {timeAgo, setTimeAgo} = useTimeAgo(data.sentAt);
    
    return (
        <div className="flex flex-row gap-1 text-left">
            <div onClick={() => { onClick(); console.log("clicked") }}
                 className="flex flex-row gap-2 w-full shadow-main items-center rounded-xl p-2 cursor-pointer hover:bg-primary_light transition-all duration-300">
                <div>
                    <UserBadge size={"small"} profileIconUrl={data.senderProfileUrl} profileId={1} />
                </div>
                <div className="flex-grow">
                    <div className="flex flex-row flex-grow justify-between gap-2">
                        <div className="flex flex-row items-center text-sm">
                            <div className="flex flex-row flex-wrap gap-x-1">
                                {getNotificationText(data)}
                            </div>
                        </div>
                    </div>

                    <div className="flex flex-col">
                        <div className="flex flex-row gap-1">
                            <div className="font-semibold text-sm">• {timeAgo}</div>
                        </div>
                    </div>
                </div>
                {!data.seen &&
                <div className="items-center text-primary text-4xl px-2">•</div>
                }
            </div>

        </div>
    )
}

